import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { ColorRing } from 'react-loader-spinner';
import { useTranslation } from 'react-i18next';

import { pieSnapActivationsChartOptions } from './pieChartSnapTrapOptions';

// eslint-disable-next-line import/order
import { useGetTrapDetailPieActivationsChartData } from 'hooks/Traps/Trap/useGetTrapDetailPieActivatioChartData';
import { TrapType } from 'components/AnalyticsPage/TrapType';

interface ChartCardProps {
  slug: string;
  type: TrapType;
}

const PieActivationsChart: React.FC<ChartCardProps> = ({ slug, type }) => {
  const { data, isLoading } = useGetTrapDetailPieActivationsChartData(slug, type);
  const { t } = useTranslation();

  const chartLOptions = pieSnapActivationsChartOptions(
    data ? { series: data.L, labels: data.labels } : { series: [], labels: [] },
    t,
    'L',
  );
  const chartROptions = pieSnapActivationsChartOptions(
    data ? { series: data.R, labels: data.labels } : { series: [], labels: [] },
    t,
    'R',
  );

  if (isLoading) {
    return (
      <div className="card d-flex m-0">
        <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '350px' }}>
          <ColorRing
            visible
            height="80"
            width="80"
            ariaLabel="color-ring-loading"
            wrapperStyle={{}}
            wrapperClass="color-ring-wrapper"
            colors={['#9C7AE2', '#E27A8C', '#C0E27A', '#7AE2D0', '#F7F18F']}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="card-body">
      <div className="row mt-4">
        {!(chartLOptions.series?.[0] === 0 && chartLOptions.series?.[1] === 0) && (
          <div className="col-xxl-6">
            <ReactApexChart options={chartLOptions} series={chartLOptions.series} type="donut" height={375} />
          </div>
        )}
        {!(chartROptions.series?.[0] === 0 && chartROptions.series?.[1] === 0) && (
          <div className="col-xxl-6">
            <ReactApexChart options={chartROptions} series={chartROptions.series} type="donut" height={375} />
          </div>
        )}
      </div>
    </div>
  );
};

export default PieActivationsChart;
